import logo from "./logo.svg";
import "./App.scss";

import { Routes, Route } from "react-router-dom";

import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { Services } from "./pages/Services";
import { LucidAware } from "./pages/LucidAware";
import { LucidMRP } from "./pages/LucidMRP";
import { LucidQuality } from "./pages/LucidQuality";
import { LucidShopFloor } from "./pages/LucidShopFloor";
import { LucidVisualScheduler } from "./pages/LucidVisualScheduler";
import { LucidWarehouse } from "./pages/LucidWarehouse";
import { ComplianceAppPage } from "./pages/ComplianceAppPage";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<Services />} />

        <Route path="/modules/lucid-aware" element={<LucidAware />} />
        <Route path="/modules/lucid-mrp" element={<LucidMRP />} />
        <Route path="/modules/lucid-quality" element={<LucidQuality />} />
        <Route path="/modules/lucid-shop-floor" element={<LucidShopFloor />} />
        <Route
          path="/modules/lucid-visual-scheduler"
          element={<LucidVisualScheduler />}
        />
        <Route path="/modules/lucid-warehouse" element={<LucidWarehouse />} />

        <Route path="/modules/compliance-app" element={<ComplianceAppPage />} />
      </Routes>
    </div>
  );
}

export default App;
